 <!-- <button nz-button nzType="default"  style="margin-bottom:20px" (click)="addPoc()">
    <nz-icon nzType="plus" /> People
  </button> -->

<nz-table #basicTable [nzData]="clientData?.poc_details" [nzBordered]="false" [nzSize]="'small'" [nzShowPagination]="false">
    <thead>
      <tr>

        <th>Name</th>
        <th>Type</th>
        <th>Email</th>
        <th>Linkedin</th>
        <th>Phone</th>
        <!-- <th>Actions</th> -->
      </tr>
    </thead>
    <tbody>
      <tr  *ngFor="let poc of clientData?.poc_details">
        <ng-container *ngIf=" editId == null; else editRow">

          <td>{{ poc.poc_name }}</td>
          <td>{{ poc.type_name }}</td>
          <td [nzAlign]="'left'"> <a *ngIf="poc.poc_email != null && poc.poc_email.length > 0" href="mailto:{{ poc.poc_email }}" target="_blank"  nz-tooltip [nzTooltipTitle]="poc.poc_email" nzTooltipPlacement="top"> <nz-icon nzType="mail" nzTheme="fill" /></a> <span *ngIf="poc.poc_email == '' || poc.poc_email == null"><nz-icon nzType="mail" nzTheme="fill" class="disabledLink" /></span> </td>
          <td [nzAlign]="'left'"> <a *ngIf="poc.poc_linkedin != null && poc.poc_linkedin.length > 0"  href="{{ poc.poc_linkedin }}" target="_blank"  nz-tooltip [nzTooltipTitle]="poc.poc_linkedin" nzTooltipPlacement="top" > <nz-icon nzType="linkedin" nzTheme="fill"  /></a> <span *ngIf="poc.poc_linkedin == '' || poc.poc_linkedin == null"><nz-icon nzType="linkedin" nzTheme="fill" class="disabledLink" /></span> </td>
          <td>{{ poc.poc_phone }}</td>
          <!-- <td>
            <button nz-button nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Edit Contact" nzTooltipPlacement="top" (click)="startEdit(poc)" class="action-button">
              <i nz-icon nzType="edit"></i>
            </button>
            <button nz-button nzDanger nzShape="circle" nzSize="small" nz-tooltip nzTooltipTitle="Delete Contact" nzTooltipPlacement="top" (click)="delete(poc)" class="action-button">
              <i nz-icon nzType="delete"></i>
            </button>
            <button nz-button nzShape="circle" [nzSize]="'small'" nz-tooltip nzTooltipTitle="Set Primary Contact" nzTooltipPlacement="top" (click)="setPrimary(poc)" class="action-button">
                <i nz-icon nzType="star" nzTheme="fill" style="color:rgb(245, 221, 6)"></i>
            </button>
          </td> -->
        </ng-container>
  
        <ng-template #editRow [formGroup]="editForm">
          <td><input nz-input formControlName="poc_name" /></td>
          <td><input nz-input formControlName="type_name" /></td>
          <td><input nz-input formControlName="poc_email" /></td>
          <td><input nz-input formControlName="poc_linkedin" /></td>
          <td><input nz-input formControlName="poc_phone" /></td>
          <td  nz-flex [nzVertical]="false" [nzAlign]="'center'" [nzJustify]="'space-between'">
            <button nz-button nzShape="circle" [nzSize]="'small'" (click)="save(poc.id)" class="action-button">  <i nz-icon nzType="save"></i></button>
            <button nz-button nzShape="circle" [nzSize]="'small'" (click)="cancel()" class="action-button">  <i nz-icon nzType="close"></i></button>
          </td>
        </ng-template>
      </tr>
    </tbody>
  </nz-table>

 

  <nz-modal 
  [nzVisible]="isNewPOC"
  [nzClosable]="true"
  [nzMaskClosable]="false"
  [nzOkDisabled]="editForm.invalid"
  [nzCentered]="true"
  nzTitle="Add New POC"
  (nzOnCancel)="handleCancel()"
  (nzOnOk)="saveNewPOC()"
>
<div *nzModalContent> 
  <form   [formGroup]="editForm"  (ngSubmit)="saveNewPOC()">
    <div class="form-grid">
     
      <div class="form-item">
        <label>Name</label>
        <input nz-input formControlName="poc_name" />`
      </div>

      <div class="form-item">
        <label>Type</label>
        <input nz-input formControlName="type_name" />
      </div>

      <div class="form-item">
        <label>Email</label>
        <input nz-input type="email" formControlName="poc_email" />
      </div>

      <div class="form-item">
        <label>LinkedIn</label>
        <input nz-input formControlName="poc_linkedin" />
      </div>

      <div class="form-item">
        <label>Phone</label>
        <input nz-input formControlName="poc_phone" />
      </div>
    </div>
  </form>
</div>
</nz-modal>